import script from "./UserPgMoshikomi.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPgMoshikomi.vue?vue&type=script&setup=true&lang=js"

import "./UserPgMoshikomi.vue?vue&type=style&index=0&id=d183490e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d183490e"]])

export default __exports__